import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import * as styles from '~styles/components/arrow.module.scss'
import Sprite from '~components/Sprite'

class Arrow extends Component {
  scroll (e) {
    e.preventDefault()

    window.scrollTo({
      top: parseInt(this.props.offset),
      behavior: 'smooth'
    })
  }

  render () {
    return (
      <button
        type="button"
        onClick={this.scroll.bind(this)}
        aria-label="Back to top"
        className={classNames(styles.arrow, 'icon iconMd', this.props.className)}
      >
        <span className={styles.icon}>
          <Sprite name="arrow" />
        </span>
      </button>
    )
  }
}

Arrow.propTypes = {
  className: PropTypes.string,
  offset: PropTypes.number
}

Arrow.defaultProps = {
  offset: 0
}

export default Arrow
